module.exports = __webpack_public_path__ + "static/media/logo.b540d37c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo.svg
// module id = 550
// module chunks = 0